import { toGroupTagsArgs } from '@components/TagDialog/TagDialog.utils';
import { TagDialogHover } from '@components/TagDialog/TagDialogHover';
import { ITag, ITagRaw } from '@models/Tag.model';
import { RelatedTagsList } from '@pages/Updates/components/UpdatesNew/components/RelatedTagsList/RelatedTagsList';

interface RTWTDProps {
  tags: ITag[] | ITagRaw[];
}
/** Optional component to avoid passing both hover and tagslist */
export function RelatedTagsListWithTagDialog(props: RTWTDProps) {
  const { tags } = props;
  return (
    <TagDialogHover tags={tags}>
      <RelatedTagsList tags={toGroupTagsArgs(tags)[0]} />
    </TagDialogHover>
  );
}
